// extracted by mini-css-extract-plugin
export default {"verifyPage":"VerifyEmail_verifyPage__HgD58","loadingText":"VerifyEmail_loadingText__W2iMa","verifiedText":"VerifyEmail_verifiedText__8Lngu"};